import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = { editEvent: false };

const eventEditSlice = createSlice({
  name: "events",
  initialState,
  reducers: {
    setEditEvent: (_, action: PayloadAction<{ editEvent: boolean }>) => {
      return action.payload;
    },
  },
});

export const { setEditEvent } = eventEditSlice.actions;
export default eventEditSlice.reducer;
